import { queryGraphQL,mutateGraphQL } from 'common/util/query';
import { toMutation, toQuery, nodeWithArgs } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { binderInstitutionIdSelector } from 'common/selectors';
import lodash from 'lodash';

export const LOAD_STUDY_ROLES = 'LOAD_STUDY_ROLES';
export const ADD_STUDY_ROLE = 'ADD_STUDY_ROLE';

export function loadStudyRoles(institutionId) {
    return (dispatch, setState) => {
        const state = setState();
        const institutionId = binderInstitutionIdSelector(state);
        
        const query = nodeWithArgs('rolesManagementForInstitution', {
            institutionId,
        }, [
            'id',
            'name',
            'isSystem'
        ]);

        return queryGraphQL(toQuery(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to retrieve roles for institution'));
            } else {
                const doaRoles = results.data.rolesManagementForInstitution;
                const nonSystemRoles = lodash
                    .filter(doaRoles, role => role.isSystem === false)
                    .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
                const systemRoles = lodash
                    .filter(doaRoles, role => role.isSystem === true)
                    .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
                const newDoaRoles = lodash.concat(systemRoles, nonSystemRoles);

                dispatch({
                    type: LOAD_STUDY_ROLES,
                    payload: newDoaRoles,
                });
            }    
        });
    };
}

export function addStudyRole(institutionId, name) {
    return (dispatch, getState) => {
        const query = nodeWithArgs('createRolesManagement', {
            institutionId,
            name
        }, [
            'id',
            'name',
            'isSystem',
        ]);
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to add role to institution'));
            } else {
                dispatch({
                    type: ADD_STUDY_ROLE,
                    payload: results.data.createRolesManagement,
                });
            }
        });
    };
}
